import Lenis from 'lenis';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/all';
import SplitType from 'split-type';
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

// Initialize Lenis
const lenis = new Lenis();
// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

function getLenis() {
    return lenis;
}
function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top < window.innerHeight &&
        rect.bottom >= 0
    );
}
const pointer = {
    x: 0,
    y: 0,
}
const getScreenType = () => {
    const width = window.innerWidth;
    let type = width > 1025 ? 'dsk' : window.innerWidth > 767 ? 'tb' : 'mb';
    let size = width;
    const isMobile = width <= 767;
    const isTablet = width > 767 && width <= 1025;
    const isDesktop = width > 1025;
    return { type, size, isMobile, isDesktop, isTablet };
}
const lerp = (a, b, t = 0.08) => {
    return a + (b - a) * t;
}
const xSetter = (el) => gsap.quickSetter(el, 'x', `px`);
const ySetter = (el) => gsap.quickSetter(el, 'y', `px`);
const xGetter = (el) => gsap.getProperty(el, 'x');
const yGetter = (el) => gsap.getProperty(el, 'y');

window.addEventListener('pointermove', updatePointer)
function updatePointer(e) {
    pointer.x = e.clientX
    pointer.y = e.clientY
}
function getPointer() {
    return pointer
}
const parseRem = (input) => {
    return (input / 10) * parseFloat(getComputedStyle(document.querySelector('html')).fontSize)
}

function refreshOnBreakpoint() {
    const breakpoints = [480, 768, 992, 1025];
    const initialViewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const breakpoint = breakpoints.find(bp => initialViewportWidth < bp) || breakpoints[breakpoints.length - 1];

    window.addEventListener('resize', debounce(function () {
        const newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if ((initialViewportWidth < breakpoint && newViewportWidth >= breakpoint) ||
            (initialViewportWidth >= breakpoint && newViewportWidth < breakpoint)) {
            location.reload();
        }
    }));
}
refreshOnBreakpoint();

function animRevealTitle(el, color = 'white', isFast = false) {
    if (!el) return
    let title = new SplitType(el, { types: 'lines, words' });
    const isColorDefault = color === 'white' || color === 'black';
    let fromColor = !isColorDefault ? 'rgba(255,255,255, .1)' : color == 'white' ? 'rgba(255,255,255, .1)' : 'rgba(29,29,29, .1)';
    let toColor = !isColorDefault ? color : color == 'white' ? 'rgba(255,255,255, 1)' : 'rgba(29,29,29, 1)';

    gsap.set(title.words, { color: fromColor, overwrite: true })
    let isReset = true;

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: 'top top+=65%',
            end: 'bottom top+=65%',
            onEnter: () => {
                if (isReset) {
                    isReset = false;
                    gsap.to(title.words, {
                        keyframes: {
                            color: [fromColor, '#FF6B30', toColor],
                            easeEach: 'power2.in',
                            ease: 'power1.out',
                        },
                        overwrite: true,
                        duration: isFast ? .8 : 1,
                        stagger: isFast ? .03 : .08,
                    })
                }
            },
        }
    })
    let resetTL = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            onLeaveBack: () => {
                if (!isReset) {
                    isReset = true;
                    gsap.set(title.words, { color: fromColor, overwrite: true })
                }
            },

        }
    })
}
function checkOS() {
    let deviceInfo = window.deviceInfo;
    if (typeof window == "undefined") return {};

    if (typeof deviceInfo == "undefined") {
        var unknown = "-";

        // screen
        var screenSize = "";
        if (screen.width) {
            var width = screen.width ? screen.width : "";
            var height = screen.height ? screen.height : "";
            screenSize += "" + width + " x " + height;
        }

        // browser
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browser = navigator.appName;
        var version = "" + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // Opera
        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browser = "Opera";
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Opera Next
        if ((verOffset = nAgt.indexOf("OPR")) != -1) {
            browser = "Opera";
            version = nAgt.substring(verOffset + 4);
        }
        // Edge
        else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
            browser = "Microsoft Edge";
            version = nAgt.substring(verOffset + 5);
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browser = "Microsoft Internet Explorer";
            version = nAgt.substring(verOffset + 5);
        }
        // Chrome
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browser = "Chrome";
            version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browser = "Safari";
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf("Version")) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browser = "Firefox";
            version = nAgt.substring(verOffset + 8);
        }
        // MSIE 11+
        else if (nAgt.indexOf("Trident/") != -1) {
            browser = "Microsoft Internet Explorer";
            version = nAgt.substring(nAgt.indexOf("rv:") + 3);
        }
        // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() == browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(";")) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(" ")) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(")")) != -1) version = version.substring(0, ix);

        majorVersion = parseInt("" + version, 10);
        if (isNaN(majorVersion)) {
            version = "" + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        var cookieEnabled = navigator.cookieEnabled ? true : false;

        if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = document.cookie.indexOf("testcookie") != -1 ? true : false;
        }

        // system
        var os = unknown;
        var clientStrings = [
            { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
            { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
            { s: "Windows Vista", r: /Windows NT 6.0/ },
            { s: "Windows Server 2003", r: /Windows NT 5.2/ },
            { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
            { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
            { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
            { s: "Windows 98", r: /(Windows 98|Win98)/ },
            { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
            { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: "Windows CE", r: /Windows CE/ },
            { s: "Windows 3.11", r: /Win16/ },
            { s: "Android", r: /Android/ },
            { s: "Open BSD", r: /OpenBSD/ },
            { s: "Sun OS", r: /SunOS/ },
            { s: "Linux", r: /(Linux|X11)/ },
            { s: "iOS", r: /(iPhone|iPad|iPod)/ },
            { s: "Mac OS X", r: /Mac OS X/ },
            { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: "QNX", r: /QNX/ },
            { s: "UNIX", r: /UNIX/ },
            { s: "BeOS", r: /BeOS/ },
            { s: "OS/2", r: /OS\/2/ },
            { s: "Search Bot", r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
        ];
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        var osVersion = unknown;

        if (/Windows/.test(os)) {
            const _osv = /Windows (.*)/.exec(os) || [];
            osVersion = _osv[1] || "unknown";
            os = "Windows";
        }

        switch (os) {
            case "Mac OS X":
                const _osvx = /Mac OS X (10[\.\_\d]+)/.exec(nAgt);
                osVersion = _osvx?.[1] || "unknown";
                break;

            case "Android":
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)?.[1] || "unknown";
                break;

            case "iOS":
                const _osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer) || [0, 0, 0];
                osVersion = (_osVersion[1] || 0) + "." + (_osVersion[2] || 0) + "." + (_osVersion[3] || 0);
                break;
        }

        const _deviceInfo = {
            screen: screenSize,
            browser: browser,
            browserVersion: version,
            browserMajorVersion: majorVersion,
            mobile: mobile,
            os: os,
            osVersion: osVersion,
            cookies: cookieEnabled,
        };

        deviceInfo = _deviceInfo;
    }

    return deviceInfo;
};
function animRevealLabel(el, color = 'white') {
    if (!el) return
    let label = new SplitType(el, { types: 'words, chars' });
    const isColorDefault = color === 'white' || color === 'black';
    let fromColor = !isColorDefault ? 'rgba(255,255,255, .1)' : color == 'white' ? 'rgba(255,255,255, .1)' : 'rgba(29,29,29, .1)';
    let toColor = !isColorDefault ? color : color == 'white' ? 'rgba(255,255,255, 1)' : 'rgba(29,29,29, 1)';
    gsap.set(label.chars, { color: fromColor, overwrite: true })
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: 'top top+=65%',
            end: 'bottom top+=65%',
            onEnter: () => {
                label.chars && gsap.to(label.chars, {
                    keyframes: {
                        color: [fromColor, '#FF6B30', toColor],
                        easeEach: 'power2.in',
                        ease: 'power1.out',
                    },
                    overwrite: true,
                    duration: .8,
                    stagger: .02,
                    onComplete: () => {
                        label.revert()
                    }
                })
            },
        }
    })

}
function debounce(func, delay = 100) {
    let timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, delay, event);
    };
}
function activeItem(items, index) {
    items.forEach(item => {
        item.classList.remove('active')
    })
    items[index].classList.add('active')
}
function handleClickOutSide({ element, action }) {
    const listener = (event) => {
        if (!element || element.contains(event.target)) {
            return;
        }
        action();
    }
    document.addEventListener('mousedown', listener, { passive: true });
    document.addEventListener('touchstart', listener, { passive: true });
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = '{{ amount_no_decimals }}';

    function formatWithDelimiters(number) {
        var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
        var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return Shopify.currency.active + " " + value;
}

class SlideText {
    constructor(wrapEl) {
        this.wrapEl = wrapEl;
        this.tlMaster;
        this.allItems = [];
    }
    setupHtml() {
        this.allItems = this.wrapEl.innerText.split('/');
        this.wrapEl.innerHTML = '';
        this.wrapEl.classList.add('txt-slider-wrap');
        this.inner = document.createElement('div');
        this.inner.classList.add('txt-slider-inner');
        this.wrapEl.appendChild(this.inner);
        this.allItems.forEach((el, idx) => {
            if (idx == 0) {
                let item = document.createElement('div');
                item.classList.add('txt-slider-item');
                item.innerText = el;
                this.inner.appendChild(item);
            }
        })
    }
    setupAnim() {
        this.allItems.forEach((el, idx) => {
            if (idx != 0) {
                let item = document.createElement('div');
                item.classList.add('txt-slider-item');
                item.innerText = el;
                this.inner.appendChild(item);
            }
        })
        let allSlideItems = this.wrapEl.querySelectorAll('.txt-slider-inner > *');
        let allWidth = [];
        let isInit = true;
        this.tlMaster = gsap.timeline({
            paused: true,
            onUpdate: (self) => {
                // let index = Math.floor(this.tlMaster.progress() / (1 / allSlideItems.length).toFixed(2)) == allSlideItems.length ? 0 : Math.floor(this.tlMaster.progress() / (1 / allSlideItems.length).toFixed(2));
                // if (isInit) {
                //     isInit = false;
                //     gsap.set(this.wrapEl, {'--textWidth': allWidth[1]})
                //     if (!this.wrapEl.classList.contains('animate')) {
                //         this.wrapEl.classList.add('animate')
                //     }
                // } else {
                //     gsap.set(this.wrapEl, {delay: DEFAULT.duration / 3, '--textWidth': allWidth[index]})
                // }
            },
            onComplete: () => {
                this.tlMaster.progress(0);
            }
        });

        const DEFAULT = {
            duration: 3,
            ease: 'expo.inOut',
            transform: {
                out: `translateY(70%)`,
                in: `translateY(-70%)`,
            }
        }
        allSlideItems.forEach((text, idx) => {
            let textWidth = text.offsetWidth;
            allWidth.push(textWidth);

            if (idx == allSlideItems.length - 1) {
                gsap.set(text, { transform: 'none', autoAlpha: 1 });
            } else {
                gsap.set(text, { transform: DEFAULT.transform.out, autoAlpha: 0 });
            }
            let tlChild = gsap.timeline({
            });

            if (idx === allSlideItems.length - 1) {
                tlChild
                    .set(text, { transform: 'none', autoAlpha: 1 })
                    .to(text, { transform: DEFAULT.transform.in, autoAlpha: 0, duration: DEFAULT.duration, ease: DEFAULT.ease }, '<=0')
                    .to(text, { duration: DEFAULT.duration * idx - 1 * DEFAULT.duration })
                    .set(text, { transform: DEFAULT.transform.out, autoAlpha: 0 })
                    .to(text, { transform: 'none', autoAlpha: 1, duration: DEFAULT.duration, ease: DEFAULT.ease });
            } else {
                tlChild
                    .set(text, { transform: DEFAULT.transform.out, autoAlpha: 0 })
                    .to(text, { duration: DEFAULT.duration * idx }, '<=0')
                    .to(text, { transform: 'none', autoAlpha: 1, duration: DEFAULT.duration, ease: DEFAULT.ease })
                    .to(text, { transform: DEFAULT.transform.in, autoAlpha: 0, duration: DEFAULT.duration, ease: DEFAULT.ease })
                    .to(text, { duration: (allSlideItems.length - 2 - idx) * DEFAULT.duration });
            }
            this.tlMaster.add(tlChild, 0);
        });
        this.tlMaster.progress((1 / allSlideItems.length).toFixed(2));
    }
    play() {
        this.tlMaster.play();
    }
}

class TextSplit {
    constructor({ el, type }) {
        replaceHyphen(el);
        this.DOM = { el: el, splitType: new SplitType(el, { types: type || 'lines' }) };
        this.init()
    }
    async loadedFont() {
        document.fonts.ready.then((fontFaceSet) => {
            this.DOM.splitType = new SplitType(this.DOM.el, { types: 'lines' });
            console.log('reInit');
            this.DOM.splitType.lines?.length && gsap.set(this.DOM.splitType.lines, { yPercent: 110 });
        })
    }

    init() {
        this.DOM.el.classList.add('text__mask');
        this.DOM.splitType.lines &&
            this.DOM.splitType.lines.forEach((line) => {
                const div = document.createElement('div');
                div.appendChild(line);
                div.classList.add('line__mask');
                this.DOM.el.appendChild(div);
            });
    }
}

const MathMap = (x, a, b, c, d) => {
    return parseFloat((((x - a) * (d - c)) / (b - a) + c).toFixed(3));
}
class MaskText {
    constructor({ el, delay, isDisableRevert }) {
        this.DOM = { el: el };
        this.textSplit = (new TextSplit({ el })).DOM.splitType;
        this.animation = null;
        this.delay = delay;
        this.isDisableRevert = isDisableRevert
        this.textSplit.lines?.length && gsap.set(this.textSplit.lines, { yPercent: 110 });

        ServicesTrigger({
            triggerEl: el,
            animEnter: this.play.bind(this),
            animInit: this.init.bind(this),
        });
    }
    init() {
        gsap.set(this.textSplit.lines, { yPercent: 105 });
    }
    play(tweenVar) {
        this.animation = gsap.to(this.textSplit.lines, {
            ...tweenVar,
            yPercent: 0,
            stagger: 0.1,
            duration: 1,
            ease: 'power3.out',
            delay: this.delay,
            clearProps: this.isDisableRevert ? '' : 'all'
        })
    }
    revert() {
        if (this.isDisableRevert) return
        this.textSplit.revert();
        // this.animation && this.animation.kill();
        // this.animation && this.animation.revert();
        // this.animation.scrollTrigger && this.animation.scrollTrigger.kill();
    }
}
class Line {
    /**
     * @param {string} type: top, left, center
     */

    constructor({ el, type, isCenter, delay, isDisableRevert }) {
        this.DOM = { el: el };
        this.animation = null;
        this.isDisableRevert = isDisableRevert;
        this.type = type || 'default';
        this.options = {
            top: {
                set: {
                    scaleY: 0,
                    transformOrigin: isCenter ? 'center center' : 'top left'
                },
                to: {
                    scaleY: 1,
                    delay
                }
            },
            left: {
                set: {
                    scaleX: 0,
                    transformOrigin: isCenter ? 'center center' : 'top left'
                },
                to: {
                    scaleX: 1,
                    delay
                }
            },
            right: {
                set: {
                    scaleX: 0,
                    transformOrigin: isCenter ? 'center center' : 'top right'
                },
                to: {
                    scaleX: 1,
                    delay
                }
            },
            default: {
                set: {
                    scaleX: 0,
                    transformOrigin: isCenter ? 'center center' : 'top left'
                },
                to: {
                    scaleX: 1,
                    delay
                }
            }
        };

        ServicesTrigger({
            triggerEl: el,
            animEnter: this.play.bind(this),
            animInit: this.init.bind(this),
        });
    }
    init() {
        gsap.set(this.DOM.el, { ...this.options[this.type]?.set || this.options.default.set });
    }
    play(tweenVar) {
        this.animation = gsap.fromTo(this.DOM.el,
            { ...this.options[this.type]?.set || this.options.default.set }, {
            ...this.options[this.type]?.to || this.options.default.to,
            duration: 1.2, ease: 'power1.out',
            ...tweenVar,
            clearProps: this.isDisableRevert ? '' : 'all'
        });
    }
    revert() {
        if (this.isDisableRevert) return

        // this.animation && this.animation.kill();
        // this.animation && this.animation.revert();
        // this.animation.scrollTrigger && this.animation.scrollTrigger.kill();
    }
}
class Fade {
    /**
     * @param {string} type: bottom | default
     */

    constructor({ el, type, delay, from, to, isDisableRevert }) {
        this.DOM = { el: el };
        this.animation = null;
        this.isDisableRevert = isDisableRevert;
        this.type = type || 'default';
        this.options = {
            bottom: {
                set: {
                    opacity: 0,
                    y: parseRem(32),
                    ...from
                },
                to: {
                    opacity: 1,
                    y: 0,
                    delay,
                    ...to
                }
            },
            left: {
                set: {
                    opacity: 0,
                    x: parseRem(32),
                    ...from
                },
                to: {
                    opacity: 1,
                    x: 0,
                    delay,
                    ...to
                },
            },
            right: {
                set: {
                    opacity: 0,
                    x: parseRem(-32),
                    ...from
                },
                to: {
                    opacity: 1,
                    x: 0,
                    delay,
                    ...to
                }
            },
            default: {
                set: {
                    opacity: 0,
                    y: parseRem(32),
                    ...from
                },
                to: {
                    opacity: 1,
                    y: 0,
                    delay,
                    ...to
                }
            }
        };

        ServicesTrigger({
            triggerEl: el,
            animEnter: this.play.bind(this),
            animInit: this.init.bind(this),
        });
    }
    init() {
        gsap.set(this.DOM.el, { ...this.options[this.type]?.set || this.options.default.set });
    }
    play(tweenVar) {
        this.animation = gsap.fromTo(this.DOM.el,
            {
                ...this.options[this.type]?.set || this.options.default.set
            }, {
            ...tweenVar,
            ...this.options[this.type]?.to || this.options.default.to,
            duration: 1, ease: 'power3',
            clearProps: this.isDisableRevert ? '' : 'all'
        });
    }

    revert() {
        if (this.isDisableRevert) return;

        // this.animation && this.animation.revert();
        // this.animation && this.animation.kill();
        // this.animation.scrollTrigger && this.animation.scrollTrigger.kill();
    }
}
class MaskBox {
    constructor({ el, delay, type, isDisableRevert }) {
        this.DOM = { el: el };
        this.animation = null;
        this.delay = delay;
        this.isDisableRevert = isDisableRevert
        this.DOM.borderRadius = window.getComputedStyle(this.DOM.el).getPropertyValue('border-radius') || '1rem';
        this.type = type || 'default';
        const clipPathOptions = {
            right: {
                set: { clipPath: `inset(0% 0% 100% 100% round ${this.DOM.borderRadius})` },
                to: { clipPath: `inset(0% 0% 0% 0% round ${this.DOM.borderRadius})` }
            },
            left: {
                set: { clipPath: `inset(0% 100% 100% 0% round ${this.DOM.borderRadius})` },
                to: { clipPath: `inset(0% 0% 0% 0% round ${this.DOM.borderRadius})` }
            },
            center: {
                set: { clipPath: `inset(30% 20% 30% 20% round ${this.DOM.borderRadius})` },
                to: { clipPath: `inset(0% 0% 0% 0% round ${this.DOM.borderRadius})` }
            },
            default: {
                set: { clipPath: `inset(0% 0% 100% 100% round ${this.DOM.borderRadius})` },
                to: { clipPath: `inset(0% 0% 0% 0%  round ${this.DOM.borderRadius})` }
            }
        };
        this.options = clipPathOptions;

        ServicesTrigger({
            triggerEl: el,
            animEnter: this.play.bind(this),
            animInit: this.init.bind(this),
        });
    }

    init() {
        gsap.set(this.DOM.el, { ...this.options[this.type].set });
    }
    play(tweenVar) {
        this.animation = gsap.fromTo(this.DOM.el,
            {
                ...this.options[this.type].set,
            },
            {
                ...this.options[this.type].to,
                duration: 1,
                ease: 'power3.out',
                delay: this.delay,
                overwrite: 'auto',
                clearProps: this.isDisableRevert ? '' : 'all',
                ...tweenVar,
            });
    }
    revert() {
        if (this.isDisableRevert) return;

        // this.animation && this.animation.kill();
        // this.animation && this.animation.revert();
        // this.animation.scrollTrigger && this.animation.scrollTrigger.kill();
    }
}
class ScaleBox {
    /**
     *
     * @param {type} type: bottom | default
     */

    constructor({ el, delay, from, to, type }) {
        this.DOM = { el: el, elInner: null };
        this.animation = null;
        this.type = type;
        this.options = {
            default: {
                set: {
                    scale: 1.2,
                    autoAlpha: 0,
                    ...from
                },
                to: {
                    transformOrigin: 'center',
                    delay,
                    ...to,
                    scale: 1,
                    autoAlpha: 1,
                }
            }
        };

        this.init(); // set first before trigger
        ServicesTrigger({
            triggerEl: el,
            animEnter: this.play.bind(this),
        });
    }
    init() {
        const div = document.createElement('div');
        div.appendChild(this.DOM.el.children[0]);
        div.classList.add('js-scale-box-inner');
        this.DOM.elInner = div;
        this.DOM.el.appendChild(div);
        gsap.set(this.DOM.elInner, { ...this.options[this.type]?.set || this.options.default.set });
    }
    play(tweenVar) {
        this.animation = gsap.fromTo(this.DOM.elInner,
            {
                ...this.options[this.type]?.set || this.options.default.set
            }, {
            ...tweenVar,
            ...this.options[this.type]?.to || this.options.default.to,
            duration: 1.5,
            ease: 'circ.out',
        });
    }

    revert() {
        // this.animation && this.animation.revert();
        // this.animation && this.animation.kill();
        // this.animation.scrollTrigger && this.animation.scrollTrigger.kill();
    }
}

const ServicesTrigger = ({ triggerEl, animEnter, animInit, animOut }) => {
    const isInScreen = isInViewport(triggerEl);
    const { height } = triggerEl.getBoundingClientRect();
    let offsetPercent = MathMap(height / window.innerHeight, 0, 1, 0.3, 0);
    offsetPercent = Math.max(Math.min(offsetPercent, 0.3), 0);

    if (!isInScreen) {
        const tweenVar = {
            onComplete: animOut,
            scrollTrigger: {
                trigger: triggerEl,
                markers: false,
                start: `${Number(offsetPercent) * 100}% 80%`,
                end: 'bottom top',
                once: true,
                onToggle: (self) => {
                    if (!self.isActive) {
                        animOut?.();
                    }
                }
            }
        };
        animEnter && animEnter(tweenVar)
    } else {
        animEnter({ onComplete: animOut });
    };
};
const initFirst = ({ el, cbInit }) => {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: el,
            start: 'top bottom+=100vh',
            end: 'bottom top',
            once: true,
            onEnter: cbInit,
            onToggle: (self) => {
                if (!self.isActive) {
                    tl.revert
                }
            }
        }
    })
}
function replaceHyphen(el) {
    const oldHtml = el.innerHTML;
    const newHtml = oldHtml.replaceAll("-", "<span>-</span>");
    el.innerHTML = newHtml;
}

class MasterTimeline {

    constructor({ triggerInit, timeline, tweenArr, stagger = .1, scrollTrigger }) {
        this.timeline = timeline;
        this.triggerInit = triggerInit;
        this.scrollTrigger = scrollTrigger;
        this.tweenArr = tweenArr;
        this.stagger = stagger;
        this.setup();
    }
    setup() {
        gsap.timeline({
            scrollTrigger: {
                trigger: this.triggerInit,
                start: 'top bottom+=100vh',
                end: 'bottom top',
                once: true,
                scrub: false,
                onEnter: () => {
                    this.tweenArr.forEach((item) => item.init?.())
                }
            }
        });
        if (!this.timeline) {
            this.timeline = gsap.timeline({
                scrollTrigger: {
                    start: 'top top+=90%',
                    end: '+=100%',
                    scrub: false,
                    once: true,
                    ...this.scrollTrigger
                }
            })
        };
        this.tweenArr.forEach((item) => this.timeline.add(item.animation, item.delay || `<=${this.stagger}` || "<=.1"));
    }
}

class RevealText {
    constructor({ el, color, delay, isDisableRevert, isHighlight = false, isFast = false, allowMobile, ...props }) {
        this.DOM = { el: el };
        this.color = color;
        this.textSplit = [];
        this.delay = delay;
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;
        this.textSplit = this.allowMobile && (new SplitType(this.DOM.el, { types: 'lines, words' }));
        const isColorDefault = this.color === 'white' || this.color === 'black';
        this.fromColor = !isColorDefault ? 'rgba(255,255,255, 0)' : this.color == 'white' ? 'rgba(255,255,255, 0)' : 'rgba(29,29,29, 0)';
        this.toColor = !isColorDefault ? this.color : this.color == 'white' ? 'rgba(255,255,255, 1)' : 'rgba(29,29,29, 1)';

        if (isHighlight) {
            this.animation = this.allowMobile && gsap.timeline({
                onComplete: () => {
                    if (!isDisableRevert) {
                        this.textSplit.revert();
                    }
                },
                ...props
            });
            this.allowMobile && this.textSplit.words.forEach((word, idx) => {
                let toColor = word.closest('.txt-highlight') ? '#FF6B30' : this.toColor;
                this.animation.to(word, {
                    keyframes: {
                        color: [this.fromColor, '#FF6B30', toColor],
                        easeEach: 'power2.in',
                        ease: 'power1.out',
                    },
                    duration: isFast ? 0.8 : 1
                }, idx * (isFast ? 0.03 : 0.08))
            });
        }
        else {
            this.animation = this.allowMobile && gsap.to(this.textSplit.words, {
                keyframes: {
                    color: [this.fromColor, '#FF6B30', this.toColor],
                    easeEach: 'power2.in',
                    ease: 'power1.out',
                },
                duration: isFast ? 0.8 : 1,
                stagger: isFast ? 0.03 : 0.08,
                onComplete: () => {
                    if (!isDisableRevert) {
                        this.textSplit.revert();
                    }
                },
                ...props
            })
        }
    }
    init() {
        this.allowMobile && gsap.set(this.textSplit.words, { color: this.fromColor });
    }
}
class RevealTextReset {
    constructor({ el, color, delay, isFast = false, isHighlight = false, allowMobile, ...props }) {
        this.DOM = { el: el };
        this.color = color;
        this.textSplit = [];
        this.delay = delay;
        this.isHighlight = isHighlight
        this.isFast = isFast;
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;

        this.textSplit = new SplitType(this.DOM.el, { types: 'lines, words' });
        this.isColorDefault = this.color === 'white' || this.color === 'black';
        this.fromColor = !this.isColorDefault ? 'rgba(255,255,255, 0)' : this.color == 'white' ? 'rgba(255,255,255, 0)' : 'rgba(29,29,29, 0)';
        this.toColor = !this.isColorDefault ? this.color : this.color == 'white' ? 'rgba(255,255,255, 1)' : 'rgba(29,29,29, 1)';

        if (this.isHighlight) {
            this.animation = this.allowMobile && gsap.timeline({
                onComplete: () => {
                    this.reset();
                },
                ...props
            });

            this.textSplit.words.forEach((word, idx) => {
                let toColor = word.closest('.txt-highlight') ? '#FF6B30' : this.toColor;
                this.animation.to(word, {
                    keyframes: {
                        color: [this.fromColor, '#FF6B30', toColor],
                        easeEach: 'power2.in',
                        ease: 'power1.out',
                    },
                    duration: isFast ? 0.8 : 1
                }, idx * (isFast ? 0.03 : 0.08))
            });
        }
        else {
            this.animation = this.allowMobile && gsap.to(this.textSplit.words, {
                keyframes: {
                    color: [this.fromColor, '#FF6B30', this.toColor],
                    easeEach: 'power2.in',
                    ease: 'power1.out',
                },
                duration: isFast ? 0.8 : 1,
                stagger: isFast ? 0.03 : 0.08,
                onComplete: () => {
                    this.reset();
                },
                ...props
            })
        }
    }
    init() {
        this.allowMobile ? gsap.set(this.textSplit.words, { color: this.fromColor }) : this.reset();
    }
    reset() {
        let isReset = true;
        let isInit = getScreenType().isMobile ? true : false;

        if (getScreenType().isMobile) {
            this.fromColor = !this.isColorDefault ? 'rgba(255,255,255, .1)' : this.color == 'white' ? 'rgba(255,255,255, .1)' : 'rgba(29,29,29, .1)';
        }

        let tlText = gsap.timeline();
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.DOM.el,
                start: 'top top+=65%',
                end: 'bottom top+=65%',
                onEnter: () => {
                    if (isReset && isInit) {
                        isReset = false;
                        if (this.isHighlight) {
                            this.textSplit.words.forEach((word, idx) => {
                                let toColor = word.closest('.txt-highlight') ? '#FF6B30' : this.toColor;
                                tlText.to(word, {
                                    keyframes: {
                                        color: [this.fromColor, '#FF6B30', toColor],
                                        easeEach: 'power2.in',
                                        ease: 'power1.out',
                                    },
                                    duration: this.isFast ? 0.8 : 1
                                }, idx * (this.isFast ? 0.03 : 0.08))
                            });
                        }
                        else {
                            gsap.to(this.textSplit.words, {
                                keyframes: {
                                    color: [this.fromColor, '#FF6B30', this.toColor],
                                    easeEach: 'power2.in',
                                    ease: 'power1.out',
                                },
                                overwrite: true,
                                duration: this.isFast ? .8 : 1,
                                stagger: this.isFast ? .03 : .08,
                            })
                        }
                    }
                },
            }
        })
        let resetTL = gsap.timeline({
            scrollTrigger: {
                trigger: this.DOM.el,
                start: 'top bottom',
                end: 'bottom top',
                onLeaveBack: () => {
                    if (!isInit) {
                        this.fromColor = !this.isColorDefault ? 'rgba(255,255,255, .1)' : this.color == 'white' ? 'rgba(255,255,255, .1)' : 'rgba(29,29,29, .1)';
                    }
                    isInit = true;

                    if (!isReset) isReset = true;
                    gsap.set(this.textSplit.words, { color: this.fromColor, overwrite: true })
                },
            }
        })
    }
}

class FadeIn {
    constructor({ el, type, delay, isDisableRevert, allowMobile, from, to, ...props }) {
        this.DOM = { el: el };
        this.type = type || 'default';
        this.delay = delay;
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;
        this.options = {
            bottom: {
                set: { opacity: 0, y: parseRem(32), ...from },
                to: { opacity: 1, y: 0, ...to }
            },
            left: {
                set: { opacity: 0, x: parseRem(32), ...from },
                to: { opacity: 1, x: 0, ...to },
            },
            right: {
                set: { opacity: 0, x: parseRem(-32), ...from },
                to: { opacity: 1, x: 0, ...to }
            },
            default: {
                set: { opacity: 0, y: parseRem(32), ...from },
                to: { opacity: 1, y: 0, ...to }
            }
        };

        if (!this.DOM.el) return;
        this.animation = this.allowMobile && gsap.fromTo(this.DOM.el,
            { ...this.options[this.type]?.set || this.options.default.set },
            {
                ...this.options[this.type]?.to || this.options.default.to,
                duration: 1,
                ease: 'power3',
                clearProps: isDisableRevert ? '' : 'all',
                ...props
            });
    }
    init() {
        if (!this.DOM.el) return;
        this.allowMobile && gsap.set(this.DOM.el, { ...this.options[this.type]?.set || this.options.default.set });
    }
}
class ScaleLine {
    constructor({ el, type, isCenter, delay, isDisableRevert, allowMobile, ...props }) {
        if (!el) return;

        this.DOM = { el: el };
        this.type = type || 'default';
        this.delay = delay;
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;
        this.options = {
            top: {
                set: { scaleY: 0, transformOrigin: isCenter ? 'center center' : 'top left' },
                to: { scaleY: 1 }
            },
            left: {
                set: { scaleX: 0, transformOrigin: isCenter ? 'center center' : 'top left' },
                to: { scaleX: 1 }
            },
            right: {
                set: { scaleX: 0, transformOrigin: isCenter ? 'center center' : 'top right' },
                to: { scaleX: 1 }
            },
            default: {
                set: { scaleX: 0, transformOrigin: isCenter ? 'center center' : 'top left' },
                to: { scaleX: 1 }
            }
        };
        this.animation = this.allowMobile && gsap.fromTo(this.DOM.el,
            { ...this.options[this.type]?.set || this.options.default.set },
            {
                ...this.options[this.type]?.to || this.options.default.to,
                duration: 1.2,
                ease: 'power1.out',
                clearProps: isDisableRevert ? '' : 'all',
                ...props
            });
    }
    init() {
        if (!this.DOM?.el) return;

        this.allowMobile && gsap.set(this.DOM.el, { ...this.options[this.type]?.set || this.options.default.set });
    }
}
class ScaleInset {
    constructor({ el, elInner, type, options, allowMobile }) {
        this.DOM = { el: el, elInner: elInner || el.querySelector('img') };
        this.type = type;
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;
        this.options = {
            default: {
                set: {
                    scale: 1.2,
                    autoAlpha: 0,
                },
                to: {
                    transformOrigin: 'center',
                    scale: 1,
                    autoAlpha: 1,
                }
            }
        };
        this.animation = this.allowMobile && gsap.fromTo(this.DOM.elInner,
            { ...this.options[this.type]?.set || this.options.default.set },
            {
                ...this.options[this.type]?.to || this.options.default.to, duration: 1.5, ease: 'circ.out',
                ...options,
                onComplete: () => {
                    gsap.set([this.DOM.el, this.DOM.elInner], { clearProps: 'all' });
                }
            });
    }
    init() {
        if (!this.DOM.el) return;
        if (this.allowMobile) {
            gsap.set(this.DOM.el, { overflow: 'hidden' });
            gsap.set(this.DOM.elInner, { ...this.options[this.type]?.set || this.options.default.set });
        }
    }
}

class FadeSplitText {
    constructor({ el, delay, breakType, isDisableRevert, allowMobile, ...props }) {
        if (!el) return;
        this.DOM = { el: el };
        this.allowMobile = getScreenType().isMobile ? allowMobile : true;
        this.breakType = breakType || 'lines';
        this.textSplit = this.allowMobile && (new TextSplit({ el: this.DOM.el, type: this.breakType })).DOM.splitType;
        this.delay = delay;
        this.animation = this.allowMobile && gsap.from(this.textSplit[this.breakType], {
            autoAlpha: 0,
            yPercent: 100,
            stagger: this.breakType == 'lines' ? 0.1 : 0.04,
            duration: this.breakType == 'lines' ? .6 : 1,
            ease: 'power2.out',
            clearProps: isDisableRevert ? '' : 'all',
            onComplete: () => {
                if (!isDisableRevert) {
                    this.textSplit.revert();
                }
            },
            ...props
        });
    }
    init() {
        document.fonts.onloadingdone = () => {
            this.allowMobile && gsap.set(this.textSplit[this.breakType], { autoAlpha: 0, yPercent: 100 });
        }
    }
}

function refreshTrigger() {
    const ob = new ResizeObserver(() => {
        gsap.globalTimeline.getChildren().forEach((el) => {
            if (el.scrollTrigger && el.scrollTrigger.progress === 0) {
                setTimeout(() => {
                    el?.scrollTrigger?.refresh();
                }, 500);
            }

        });
    });
    ob.observe(document.body);
    return ob
}

function updateCustomScrollbars(elements, resizeObserver) {
    elements.forEach((element) => {
        const childEles = element.querySelectorAll('*');
        let hasScrollbar = false
        childEles.forEach((el) => {
            if (el.offsetHeight > element.offsetHeight) {
                hasScrollbar = true
            }
        })
        element.classList.toggle('custom-scroll', true);
        element.style.scrollbarGutter = 'auto';
        element.style.overflowY = 'overlay';

        if (element instanceof HTMLTextAreaElement) return;

        if (hasScrollbar) {
            element.setAttribute('data-lenis-prevent', 'true');
        } else {
            element.removeAttribute('data-lenis-prevent');
        }
        if (!element._isObserved) {
            resizeObserver.observe(element);
            element._isObserved = true;
        }
    });
}

function resizeHandler() {
    const elementsToTrack = document.querySelectorAll('[data-lenis-prevent]');

    const resizeDebounce = debounce(() => {
        refreshTrigger();
        updateCustomScrollbars(elementsToTrack, ob)
    }, 100);

    const ob = new ResizeObserver(resizeDebounce);
    updateCustomScrollbars(elementsToTrack, ob)
    ob.observe(document.body);

    return ob
}

const handleCheckLockScreen = () => {
    const isExitsSection = document.querySelector('[data-section-lock]') && !document.querySelector('html').classList.contains('shopify-design-mode');

    if (isExitsSection) {
        console.log('not lock')
    } else {
        console.log('lock section')
        document.querySelector('body').classList.contains('is-loading') && document.querySelector('body').classList.remove('is-loading')
    }
}

resizeHandler();
handleCheckLockScreen();

export { parseRem, isInViewport, getPointer, animRevealTitle, formatMoney, RevealTextReset, RevealText, ScaleInset, FadeSplitText, FadeIn, ScaleLine, MasterTimeline, checkOS, animRevealLabel, xSetter, ySetter, xGetter, yGetter, lerp, debounce, activeItem, SlideText, handleClickOutSide, getLenis, TextSplit, MathMap, MaskText, initFirst, Fade, Line, MaskBox, getScreenType, ScaleBox, replaceHyphen }